import React from 'react';

import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import cn from 'classnames';
import MainButton from '../MUI/MainButton';
import useDeviceResize from '../../hooks/useDeviceResize';

import styles from './ServiceBlock.module.scss';
import { redirectTo } from '../../helpers/menuTree/menuTree';

const ServiceBlock = ({ serviceKey, service }) => {
  const { icon, link } = service;
  const { t } = useTranslation();
  const history = useHistory();
  const isDeviceTablet = useDeviceResize('tablet');

  const iconContent = (
    <div>
      <img className={styles.icon} src={icon} alt="icon" />
    </div>
  );
  const titleContent = <Typography className={styles.title}>{t(`${serviceKey}.title`)}</Typography>;

  const linkContent = (
    <div className={styles.buttonContainer}>
      <MainButton
        variant="contained"
        className={styles.button}
        color="primary"
        onClick={(e) => redirectTo(history, link, e)}
      >
        {t(`${serviceKey}.buttonText`)}
      </MainButton>
    </div>
  );

  if (isDeviceTablet) {
    return (
      <div className={cn(styles.serviceBlock, styles.vertical)}>
        <div className={styles.headerMobile}>
          {iconContent}
          {titleContent}
        </div>
        <div className={styles.contentMobile}>{linkContent}</div>
      </div>
    );
  }

  return (
    <div className={styles.serviceBlock}>
      <div className={styles.header}>
        <div>{iconContent}</div>
      </div>
      <div className={styles.content}>
        {titleContent}
        {linkContent}
      </div>
    </div>
  );
};

ServiceBlock.propTypes = {
  serviceKey: PropTypes.string.isRequired,
  service: PropTypes.shape({
    icon: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  }).isRequired,
};

export default ServiceBlock;
